import { render, staticRenderFns } from "./sectionList.vue?vue&type=template&id=1574e9f6&scoped=true&"
import script from "./sectionList.vue?vue&type=script&lang=js&"
export * from "./sectionList.vue?vue&type=script&lang=js&"
import style0 from "./sectionList.vue?vue&type=style&index=0&id=1574e9f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1574e9f6",
  null
  
)

export default component.exports